import UserComplaintPage from "./UserComplaintPage";

export default UserComplaintPage;